import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getEndpoint ({ state, commit }, endpointName) {
      let endpoint = (await Vue.http.get(this.state.baseUrl + '/endpoints/fetch/' + endpointName)).data || null
      commit('setState', { stateName: 'endpoint', stateValue: endpoint })
      return endpoint
    },
    //Fetching ICU endpoint
    async getIcuEndpoints ({ state, commit }, options) {
      let endpoints = (await Vue.http.get(this.state.baseUrl + '/endpoints/bytype/icu?pageSize=' + (options.pageSize || 3) + '&pageNumber=' + options.pageNumber)).data
      return endpoints
    },
    async fetchIcuEndpoint ({ state }, options) {
      let data = (await Vue.http.get(this.state.baseUrl + '/endpoints/' + options.id)).data
      return data
    },
    async getEndpointByDeviceType ({ state, commit }, userId) {
      try {
        let endpoint = (await Vue.http.get(this.state.baseUrl + '/endpoints/bydevicetype/' + userId + '?deviceType=Android')).data
        return endpoint
      } catch (e) {
        throw e
      }
    },
    async updateEndPointStatus ({ state }, options) {
      let data = (await Vue.http.put(this.state.baseUrl + '/endpoints/status/' + options.endpointId, options)).data
      return data
    },
    async makeIcuAppointment ({ state }, options) {
      let data = (await Vue.http.post(this.state.baseUrl + '/appointments', options.appointment)).data
      return data
    },
    async setIcuEndpointAndIcuAppointment ({ commit }, options) {
      commit('setState', {
        stateName: 'icuEndpoint',
        stateValue: options.icuEndpoint
      })

      commit('setState', {
        stateName: 'icuAppointment',
        stateValue: options.icuAppointment
      })

    },

    async resetEndpoint ({ state }, options) {
      let data = (await Vue.http.delete(this.state.baseUrl + '/endpoints/reset/' + options.endpoint._id)).data
      return data
    },
    async getEndpointDetails ({ state }, endpointName) {
      let data = (await Vue.http.get(this.state.baseUrl + '/endpoints/fetch/' + endpointName)).data || null
      return data
    },

    async getLabEndpoints ({ }, options) {
      let endpoints = (await Vue.http.get(this.state.baseUrl + '/endpoints/search/lab' + '/' + options.searchStr + '?pageSize=5&pageNumber=' + options.pageNumber)).data
      return endpoints
    },

    async getAllLabEndpoints ({ state, commit }, options) {
      let endpoints = (await Vue.http.get(this.state.baseUrl + '/endpoints/bytype/lab?')).data
      return endpoints
    },
  }
}
